import { init } from "ityped";
import React, { useEffect, useRef, useState } from "react";
import {
  default as Col,
  default as Container,
  default as Row,
} from "react-bootstrap/Container";
import "./hero.scss";

const Hero = () => {
  const textRef = useRef();
  const [data, setData] = useState({});

  const fetchProjects = async (project_title) => {
    try {
      const response = await fetch(`/${project_title}.json`); // Assuming `html.json` is in the public folder
      const data = await response.json();
      setData(data);
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  useEffect(() => {
    fetchProjects("hero"); // Fetch default projects on initial render
  }, []);

  useEffect(() => {
    init(textRef.current, {
      showCursor: true,
      typeSpeed: 100,
      backDelay: 500,
      backSpeed: 60,
      // strings: [
      //   "Full Stack Web Developer",
      //   "Laravel Developer",
      //   "Vue Js Developer",
      //   "Nuxt Js Developer",
      //   "Node Js Developer",
      // ],
      strings: data.strings ? data.strings : [],
    });
  }, [data]);

  return (
    <>
      <section id="hero" className="hero ">
        <Container>
          <Row>
            <Col
              sm={10}
              className="mx-auto py-5 d-flex flex-column text-center"
            >
              <div className="hero_text py-2">
                <h2 className="pt-4 fw-bold">Hello, I'm</h2>
                <h1 className="fw-bold">{data.name ? data.name : ""}</h1>
                <h4 className="py-2 fs-1">
                  <span ref={textRef}> </span>
                </h4>
              </div>
              <div className="social pt-5">
                <div className="d-flex flex-row justify-content-center ">
                  {data?.socials?.map((social, index) => (
                    <a target="_blank" rel="noreferrer" href={social.link}>
                      <i className={`${social.icon} mx-lg-5 mx-sm-2`}></i>
                    </a>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Hero;
